var AWS = require('../core');

AWS.util.update(AWS.Lambda.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'invoke') {
      request.addListener('extractData', AWS.util.convertPayloadToString);
    }
  }
});




//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/lambda.js
// module id = Vaqc
// module chunks = 1